import type { ReactNode } from 'react';
import { useCallback, useMemo, useRef } from 'react';

import type { Operation } from './index.ts';
import { TMContext } from './index.ts';

type Props = {
  children: ReactNode;
};

export const TMProvider = ({ children }: Props) => {
  const operations = useRef<Operation[]>([]);

  const logOperation = useCallback((operation: Operation) => {
    operations.current.push(operation);
  }, []);

  const flushOperations = useCallback(() => {
    const res = operations.current;
    operations.current = [];
    return res;
  }, []);

  const value = useMemo(
    () => ({
      logOperation,
      flushOperations,
    }),
    [flushOperations, logOperation]
  );

  return <TMContext value={value}>{children}</TMContext>;
};
